const initstate = {
  mmmHomeAdv: {},
  zhMMMSauceAdv: {},
  zhMMMNoodlesAdv: {},
  zhMMMVideosAdv: {},
};

export function mmmState(state = initstate, action) {
  switch (action.type) {
    case 'GET_MMM_HOME_ADV': {
      return {
        ...state,
        mmmHomeAdv: action.payload,
      };
    }
    case 'GET_ZH_MMM_SAUCE_ADV': {
      return {
        ...state,
        zhMMMSauceAdv: action.payload,
      };
    }
    case 'GET_ZH_MMM_NOODLES_ADV': {
      return {
        ...state,
        zhMMMNoodlesAdv: action.payload,
      };
    }
    case 'GET_ZH_MMM_VIDEOS_ADV': {
      return {
        ...state,
        zhMMMVideosAdv: action.payload,
      };
    }
    default:
      return state;
  }
}

export default mmmState;
